import React from 'react'
import { RouterProvider } from 'react-router-dom'
import routes from './router/routes'

export default function Main() {
  return <RouterProvider router={routes()} />
}
